import Vue from 'vue'

const sanitizeHTML = (html) => {
	const scriptRegex = new RegExp('<script[^>]*>(.*?)</script[^>]*>', 'gmi')
	return html.replace(scriptRegex, '')
}

Vue.prototype.$sanitize = sanitizeHTML
